//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as Sentry from '@sentry/browser';
import outside from 'vue-outside';
import {catchError} from 'gso-onerror';
import {parse} from 'content-type';
import {every, stop} from 'visibilityjs';
import NotificationsIcon from 'gso-design-icons/vue/material-design/notifications.vue';
import NotificationsNoneIcon from 'gso-design-icons/vue/material-design/notifications_none.vue';
import CheckIcon from 'gso-design-icons/vue/material-design/check.vue';
import MailOutlineIcon from 'gso-design-icons/vue/material-design/mail_outline.vue';
import InboxIcon from 'gso-design-icons/vue/material-design/inbox.vue';
import ArrowDropDownIcon from 'gso-design-icons/vue/material-design/arrow_drop_down.vue';

import AlarmIcon from 'gso-design-icons/vue/material-design/alarm.vue';
import InfoIcon from 'gso-design-icons/vue/material-design/info.vue';
import TaskIcon from 'gso-design-icons/vue/apps/itask.vue';
import ApprovalIcon from 'gso-design-icons/vue/material-design/approval.vue';
import AssignmentIcon from 'gso-design-icons/vue/apps/draw.vue';
import ConsentIcon from 'gso-design-icons/vue/apps/handshake.vue';
import CheckBoxIcon from 'gso-design-icons/vue/material-design/check_box.vue';
import CheckBoxOutlineBlankIcon from 'gso-design-icons/vue/material-design/check_box_outline_blank.vue';
import isLoggedIn from '../is-logged-in';
import resolveUrl from '../mixins/resolve-url';
import {
	getNotifications,
	markNotificationsAsRead
} from '../proxies/hecate-proxy';
import en from '../../i18n/en.json';
import fr from '../../i18n/fr.json';
import nl from '../../i18n/nl.json';

const DELAY = 60 * 1000; // 1 min
let timerId;

async function catchInvalidTokenError(error) {
	const response = error.response;

	if (!response || !response.headers) {
		Sentry.captureException(error);
		catchError(error);
		return;
	}

	const type = parse(response.headers.get('Content-Type')).type;

	if (type !== 'application/json') {
		Sentry.captureException(error);
		catchError(error);
		return;
	}

	const errorResponse = await response.json();
	const invalidTokenError = errorResponse.code === 'TKN001';

	if (!invalidTokenError) {
		Sentry.captureException(error);
		catchError(error);
		return;
	}

	stop(timerId);
	timerId = null;
}

export default {
	name: 'inbox',
	components: {
		CheckBoxIcon,
		CheckBoxOutlineBlankIcon,
		AlarmIcon,
		InfoIcon,
		TaskIcon,
		ApprovalIcon,
		AssignmentIcon,
		ConsentIcon,
		NotificationsIcon,
		NotificationsNoneIcon,
		CheckIcon,
		MailOutlineIcon,
		InboxIcon,
		ArrowDropDownIcon
	},
	directives: {
		outside
	},
	mixins: [resolveUrl],
	model: {
		prop: 'isChecked',
		event: 'changed'
	},
	props: {
		isChecked: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			notifications: [],
			notificationsCount: 0
		};
	},
	computed: {
		isOpen() {
			return this.$store.state.header.isOpen === 'inbox';
		},
		hasNotifications() {
			return this.notificationsCount > 0;
		},
		notificationsCountDisplay() {
			return this.notificationsCount;
		}
	},
	async beforeMount() {
		if (!isLoggedIn()) {
			return;
		}

		try {
			const result = await getNotifications({noLoader: true}, '');
			this.notifications = result.data;
			this.notificationsCount = result.entireListSize;
		} catch (error) {
			Sentry.captureException(error);
			catchError(error);
		}

		timerId = every(DELAY, async () => {
			try {
				const result = await getNotifications({noLoader: true}, '');
				this.notifications = result.data;
				this.notificationsCount = result.entireListSize;
			} catch (error) {
				catchInvalidTokenError(error);
			}
		});
	},
	methods: {
		toggle() {
			if (this.isOpen) {
				this.$store.commit('header/close');
			} else {
				this.$store.commit('header/open', {menu: 'inbox'});
			}
		},
		outside(event, el) {
			if (el.parentElement && !el.parentElement.contains(event.target)) {
				if (this.isOpen) {
					this.$store.commit('header/close');
				}
			}
		},
		show(notification) {
			sessionStorage.inboxAutoOpenId = notification.id;
			location.href = this.resolveUrl('../inbox');
		},
		markAllAsRead() {
			this.isChecked = true;
			let notificationList = [];
			this.notifications.forEach(item => notificationList.push(item.id));
			markNotificationsAsRead(notificationList, 1);
			this.beforeMount();
		},
		check(notification) {
			let notificationList = [];
			this.notifications.forEach(item => {
				if (item === notification) {
					notificationList.push(notification.id);
					markNotificationsAsRead(notificationList, 1);
				} else {
					this.isChecked = false;
				}
			});
			this.beforeMount();
		}
	},
	i18n: {
		messages: {
			fr: fr.inbox,
			nl: nl.inbox,
			en: en.inbox
		}
	}
};
